@if (eventos().length) {
    <!--
        `@container` no próprio `p-timeline`: as consultas abaixo medem a largura DELE, não a da
        janela — o histórico aparece largo no desktop e estreito no celular, e é a largura
        disponível que decide se cabem as duas colunas do `alternate`. Abaixo de 480px o lado
        oposto some e tudo alinha à esquerda. Mesmo recurso e mesmos limiares do kanban de
        serviços, que é onde este padrão de timeline foi estabelecido.
    -->
    <p-timeline
        [value]="eventos()"
        align="alternate"
        class="w-full @container"
        [pt]="{
            event: { class: '@max-[480px]:flex-row!' },
            eventOpposite: { class: '@max-[480px]:hidden' },
            eventContent: { class: '@max-[480px]:text-left!' },
            eventConnector: { class: 'mb-4' }
        }"
    >
        <ng-template #opposite let-evento>
            <div class="font-medium text-surface-700 dark:text-surface-200">{{ evento.data }}</div>
        </ng-template>

        <!--
            O marcador é a bandeira da UF dentro do círculo do padrão: identifica o estado da
            movimentação sem consumir uma linha de texto do card. O modificador de cor sai do
            próprio `familia` do evento, como o `.kanban-historico-marcador` faz com o `tipo`:
            assim marcador e badge não podem divergir de cor.
            `alt` diz a sigla porque a bandeira sozinha não se lê em voz alta.
        -->
        <ng-template #marker let-evento>
            <span [class]="'timeline-inscricao-marcador timeline-inscricao-marcador--' + evento.familia" [class.timeline-inscricao-marcador--cancelada]="evento.cancelada">
                <img class="timeline-inscricao-bandeira" [src]="evento.bandeira" [alt]="'UF ' + evento.uf" />
            </span>
        </ng-template>

        <ng-template #content let-evento>
            <!--
                `button`, e não a `div` do kanban: aqui o item é operável — selecioná-lo habilita
                "Cancelar Inscrição" e "Mais Informações" — e precisa ser alcançável por teclado.
                As classes do cartão são as mesmas do padrão.
            -->
            <button
                type="button"
                class="timeline-inscricao-item w-full text-left p-4 rounded-xl bg-surface-0 dark:bg-surface-800 border border-surface-200 dark:border-surface-700 shadow-sm mb-4"
                [class.timeline-inscricao-item--cancelada]="evento.cancelada"
                [class.timeline-inscricao-item--selecionada]="indiceSelecionado() === evento.indiceLinha"
                [attr.aria-pressed]="indiceSelecionado() === evento.indiceLinha"
                (click)="alternarSelecao(evento)"
            >
                <!--
                    A data repete o que o eixo já mostra, de propósito e a pedido: dentro do cartão
                    ela fica junto dos dados que a acompanham. Abaixo de 480px o `pt` esconde o lado
                    oposto, e esta passa a ser a única data do evento.
                -->
                <span class="timeline-inscricao-data-card">{{ evento.data }}</span>

                <span class="timeline-inscricao-badges">
                    <span [class]="'timeline-inscricao-badge timeline-inscricao-badge--' + evento.familia">{{ evento.descricao }}</span>
                    @if (evento.cancelada) {
                        <span class="timeline-inscricao-badge timeline-inscricao-badge--cancelada">Cancelada em {{ evento.dataCancelamento }}</span>
                    }
                </span>

                <!--
                    Os ícones são os mesmos que os cards do histórico já usam para estes dois campos
                    (`pi-map-marker` e `pi-info-circle`), para o analista não aprender um segundo
                    vocabulário ao trocar de visualização. `aria-hidden` porque o rótulo ao lado já
                    diz o que o ícone ilustra — anunciá-lo seria repetição.
                -->
                @if (evento.uf) {
                    <span class="timeline-inscricao-detalhe">
                        <i class="pi pi-map-marker" aria-hidden="true"></i>{{ evento.rotuloUf }}: <span>{{ evento.uf }}</span>
                    </span>
                }
                @if (evento.motivoCancelamento) {
                    <span class="timeline-inscricao-detalhe">
                        <i class="pi pi-info-circle" aria-hidden="true"></i>Motivo: <span>{{ evento.motivoCancelamento }}</span>
                    </span>
                }
            </button>
        </ng-template>
    </p-timeline>
} @else {
    <p class="timeline-inscricao-vazio">Nenhuma movimentação registrada.</p>
}
